export default __webpack_public_path__ + "static/media/global_agriculture_market.0dacd57a5848bf022bacbd2b0bc342f6.png";